import React from 'react';
import ModuleDetailPage from './ModuleDetailPage';

const WhatsappOrderPage = () => <ModuleDetailPage moduleId="whatsapp" />;

export default WhatsappOrderPage;
